import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string,
  String: string,
  Boolean: boolean,
  Int: number,
  Float: number,
  DateTime: any,
  Upload: any,
};



export type Channel = {
   __typename?: 'Channel',
  id: Scalars['String'],
  displayName: Scalars['String'],
  createdBy: User,
  fillerSources: Array<TranscodedSource>,
  fillerControl: FillerControl,
  permission: ChannelPermission,
};

export type ChannelList = {
   __typename?: 'ChannelList',
  total: Scalars['Int'],
  channels: Array<Channel>,
};

export enum ChannelPermission {
  Public = 'public',
  ViewerOnly = 'viewerOnly'
}


export enum DeviceType {
  Browser = 'browser',
  Chromecast = 'chromecast'
}

export type FileSource = TranscodedSource & {
   __typename?: 'FileSource',
  id: Scalars['ID'],
  status: TranscodeStatus,
  duration?: Maybe<Scalars['Float']>,
  thumbnailUrl?: Maybe<Scalars['String']>,
  width?: Maybe<Scalars['Int']>,
  height?: Maybe<Scalars['Int']>,
  name: Scalars['String'],
  createdAt: Scalars['DateTime'],
  updatedAt: Scalars['DateTime'],
  createdBy: User,
  preset?: Maybe<TranscodePreset>,
  type: SourceType,
  /** additional props */
  source: FileSourceOrignalInfo,
  error?: Maybe<Scalars['String']>,
  transcodeProgress?: Maybe<Scalars['Float']>,
  isProbing: Scalars['Boolean'],
};

export type FileSourceList = {
   __typename?: 'FileSourceList',
  sources: Array<FileSource>,
  total: Scalars['Int'],
};

export type FileSourceOrignalInfo = {
   __typename?: 'FileSourceOrignalInfo',
  status: SourceStatus,
  extension: Scalars['String'],
  width?: Maybe<Scalars['Int']>,
  height?: Maybe<Scalars['Int']>,
  fileSize: Scalars['Int'],
  duration?: Maybe<Scalars['Float']>,
};

export enum FillerControl {
  Random = 'random',
  Sequential = 'sequential'
}

export enum IdPType {
  Twitter = 'twitter'
}

export type Mutation = {
   __typename?: 'Mutation',
  /** admin func */
  createFileSourceUpload: FileSource,
  uploadFileSourceChunk: Scalars['Boolean'],
  probeFileSource: Scalars['Boolean'],
  updateSource: TranscodedSource,
  createRtmpInput: RtmpInput,
  removeRtmpInput: Scalars['Boolean'],
  createTranscodePreset: TranscodePreset,
  enqueueFileSourceTranscode: Scalars['Boolean'],
  createChannel: Channel,
  updateChannel: Channel,
  addFillerToChannel: Array<Scalars['ID']>,
  removeFillerFromChannel: Array<Scalars['ID']>,
  createSchedule: Schedule,
  updateSchedule: Schedule,
  removeSchedule: Scalars['Boolean'],
  addProgramToSchedule: Schedule,
  removeProgramFromSchedule: Schedule,
  updateProgram: Schedule,
  updateProgramOrder: Schedule,
  createViewerChallenge: ViewerChallenge,
  acceptViewerChallenge: Scalars['Boolean'],
  updateViewer: ViewerDevice,
  removeViewer: Scalars['Boolean'],
  updateViewerState: Scalars['Boolean'],
  reportViewerMetrics: Scalars['Boolean'],
  createPromoteInvite: Scalars['String'],
  consumePromoteInvite: User,
};


export type MutationCreateFileSourceUploadArgs = {
  fileInfo: UploadFileInfo
};


export type MutationUploadFileSourceChunkArgs = {
  sourceId: Scalars['ID'],
  file: UploadFileChunk
};


export type MutationProbeFileSourceArgs = {
  sourceId: Scalars['ID']
};


export type MutationUpdateSourceArgs = {
  sourceId: Scalars['ID'],
  name?: Maybe<Scalars['String']>
};


export type MutationCreateRtmpInputArgs = {
  name: Scalars['String'],
  presetId: Scalars['ID']
};


export type MutationRemoveRtmpInputArgs = {
  id: Scalars['ID']
};


export type MutationCreateTranscodePresetArgs = {
  name: Scalars['String'],
  parameter: Array<Scalars['String']>
};


export type MutationEnqueueFileSourceTranscodeArgs = {
  sourceId: Scalars['ID'],
  presetId: Scalars['ID']
};


export type MutationCreateChannelArgs = {
  id: Scalars['String'],
  displayName: Scalars['String'],
  fillerSources?: Maybe<Array<Scalars['ID']>>,
  fillerControl?: Maybe<FillerControl>,
  permission?: Maybe<ChannelPermission>
};


export type MutationUpdateChannelArgs = {
  id: Scalars['String'],
  displayName?: Maybe<Scalars['String']>,
  fillerControl?: Maybe<FillerControl>,
  permission?: Maybe<ChannelPermission>
};


export type MutationAddFillerToChannelArgs = {
  id: Scalars['String'],
  sources: Array<Scalars['ID']>
};


export type MutationRemoveFillerFromChannelArgs = {
  id: Scalars['String'],
  sources: Array<Scalars['ID']>
};


export type MutationCreateScheduleArgs = {
  channelId: Scalars['String'],
  startAt: Scalars['DateTime'],
  endAt: Scalars['DateTime'],
  title: Scalars['String']
};


export type MutationUpdateScheduleArgs = {
  scheduleId: Scalars['ID'],
  title?: Maybe<Scalars['String']>,
  startAt?: Maybe<Scalars['DateTime']>,
  endAt?: Maybe<Scalars['DateTime']>
};


export type MutationRemoveScheduleArgs = {
  scheduleId: Scalars['ID']
};


export type MutationAddProgramToScheduleArgs = {
  scheduleId: Scalars['ID'],
  before?: Maybe<Scalars['ID']>,
  duration: Scalars['Float'],
  type: ProgramType,
  sourceId?: Maybe<Scalars['ID']>
};


export type MutationRemoveProgramFromScheduleArgs = {
  scheduleId: Scalars['ID'],
  programId: Scalars['ID']
};


export type MutationUpdateProgramArgs = {
  scheduleId: Scalars['ID'],
  programId: Scalars['ID'],
  duration?: Maybe<Scalars['Float']>,
  type?: Maybe<ProgramType>,
  sourceId?: Maybe<Scalars['ID']>
};


export type MutationUpdateProgramOrderArgs = {
  scheduleId: Scalars['ID'],
  order: Array<Scalars['ID']>
};


export type MutationCreateViewerChallengeArgs = {
  device: DeviceType
};


export type MutationAcceptViewerChallengeArgs = {
  deviceId: Scalars['ID']
};


export type MutationUpdateViewerArgs = {
  deviceId: Scalars['ID'],
  displayName?: Maybe<Scalars['String']>
};


export type MutationRemoveViewerArgs = {
  deviceId: Scalars['ID']
};


export type MutationUpdateViewerStateArgs = {
  request: ViewerRequestParam
};


export type MutationReportViewerMetricsArgs = {
  metrics: ViewerMetricsParam
};


export type MutationCreatePromoteInviteArgs = {
  role: UserRole
};


export type MutationConsumePromoteInviteArgs = {
  id: Scalars['String']
};

export type Playbackable = FileSource | RecordSource | Channel;

export type Program = {
   __typename?: 'Program',
  id: Scalars['ID'],
  type: ProgramType,
  duration: Scalars['Float'],
  source?: Maybe<SourceReference>,
};

export enum ProgramType {
  Rtmp = 'rtmp',
  Transcoded = 'transcoded',
  Empty = 'empty'
}

export type Query = {
   __typename?: 'Query',
  fileSource?: Maybe<FileSource>,
  fileSourceList: FileSourceList,
  recordSource?: Maybe<RecordSource>,
  recordSourceList: RecordSourceList,
  source: SourceReference,
  sourceList: SourceList,
  rtmpInput?: Maybe<RtmpInput>,
  rtmpInputList: RtmpInputList,
  users: Users,
  channel?: Maybe<Channel>,
  channelList: ChannelList,
  schedule?: Maybe<Schedule>,
  scheduleList: ScheduleList,
  transcodePreset?: Maybe<TranscodePreset>,
  transcodePresetList: TranscodePresetList,
  viewerRequests: Array<ViewerChallengeRequest>,
  viewerDevices: ViewerDeviceList,
  viewerDevice?: Maybe<ViewerDevice>,
  /** normal func */
  me?: Maybe<User>,
  viewerChallengeResult: ViewerChallengeResult,
  viewerInfo?: Maybe<ViewerDevice>,
};


export type QueryFileSourceArgs = {
  sourceId: Scalars['ID']
};


export type QueryFileSourceListArgs = {
  status?: Maybe<TranscodeStatus>,
  skip: Scalars['Int'],
  take: Scalars['Int']
};


export type QueryRecordSourceArgs = {
  sourceId: Scalars['ID']
};


export type QueryRecordSourceListArgs = {
  skip: Scalars['Int'],
  take: Scalars['Int']
};


export type QuerySourceArgs = {
  sourceId: Scalars['ID']
};


export type QuerySourceListArgs = {
  type?: Maybe<SourceType>,
  status?: Maybe<TranscodeStatus>,
  skip: Scalars['Int'],
  take: Scalars['Int']
};


export type QueryRtmpInputArgs = {
  id: Scalars['ID']
};


export type QueryRtmpInputListArgs = {
  skip: Scalars['Int'],
  take: Scalars['Int']
};


export type QueryUsersArgs = {
  role?: Maybe<UserRole>,
  type?: Maybe<IdPType>,
  skip: Scalars['Int'],
  take: Scalars['Int']
};


export type QueryChannelArgs = {
  id: Scalars['String']
};


export type QueryChannelListArgs = {
  skip: Scalars['Int'],
  take: Scalars['Int']
};


export type QueryScheduleArgs = {
  id: Scalars['ID']
};


export type QueryScheduleListArgs = {
  skip: Scalars['Int'],
  take: Scalars['Int'],
  startAt?: Maybe<Scalars['DateTime']>,
  endAt?: Maybe<Scalars['DateTime']>,
  channel?: Maybe<Array<Scalars['String']>>
};


export type QueryTranscodePresetArgs = {
  id: Scalars['ID']
};


export type QueryTranscodePresetListArgs = {
  skip: Scalars['Int'],
  take: Scalars['Int']
};


export type QueryViewerDevicesArgs = {
  skip: Scalars['Int'],
  take: Scalars['Int']
};


export type QueryViewerDeviceArgs = {
  id: Scalars['ID']
};


export type QueryViewerChallengeResultArgs = {
  token: Scalars['String']
};

export type RecordSource = TranscodedSource & {
   __typename?: 'RecordSource',
  id: Scalars['ID'],
  status: TranscodeStatus,
  duration?: Maybe<Scalars['Float']>,
  thumbnailUrl?: Maybe<Scalars['String']>,
  width?: Maybe<Scalars['Int']>,
  height?: Maybe<Scalars['Int']>,
  name: Scalars['String'],
  createdAt: Scalars['DateTime'],
  updatedAt: Scalars['DateTime'],
  createdBy: User,
  preset: TranscodePreset,
  type: SourceType,
  /** additional props */
  source: RtmpInput,
  error?: Maybe<Scalars['String']>,
};

export type RecordSourceList = {
   __typename?: 'RecordSourceList',
  sources: Array<RecordSource>,
  total: Scalars['Int'],
};

export type RtmpInput = {
   __typename?: 'RtmpInput',
  id: Scalars['ID'],
  name: Scalars['String'],
  status: RtmpStatus,
  publishUrl: Scalars['String'],
  preset: TranscodePreset,
  createdBy: User,
};

export type RtmpInputList = {
   __typename?: 'RtmpInputList',
  inputs: Array<RtmpInput>,
  total: Scalars['Int'],
};

export enum RtmpStatus {
  Live = 'live',
  Unused = 'unused'
}

export type Schedule = {
   __typename?: 'Schedule',
  id: Scalars['ID'],
  title: Scalars['String'],
  startAt: Scalars['DateTime'],
  endAt: Scalars['DateTime'],
  channel: Channel,
  programs: Array<Program>,
  isValid: Scalars['Boolean'],
};

export type ScheduleList = {
   __typename?: 'ScheduleList',
  total: Scalars['Int'],
  schedules: Array<Schedule>,
};

export type SourceList = {
   __typename?: 'SourceList',
  sources: Array<TranscodedSource>,
  total: Scalars['Int'],
};

export type SourceReference = FileSource | RecordSource | RtmpInput;

export enum SourceStatus {
  Uploading = 'uploading',
  Available = 'available',
  Deleted = 'deleted'
}

export enum SourceType {
  File = 'file',
  Record = 'record'
}

export type Subscription = {
   __typename?: 'Subscription',
  viewerUpdate: ViewerDevice,
  viewerUpdateDevice: ViewerDevice,
  viewerRequestsPolling: Scalars['Int'],
};


export type SubscriptionViewerUpdateDeviceArgs = {
  id: Scalars['ID']
};

export type TranscodedSource = {
  id: Scalars['ID'],
  status: TranscodeStatus,
  duration?: Maybe<Scalars['Float']>,
  thumbnailUrl?: Maybe<Scalars['String']>,
  width?: Maybe<Scalars['Int']>,
  height?: Maybe<Scalars['Int']>,
  name: Scalars['String'],
  createdAt: Scalars['DateTime'],
  updatedAt: Scalars['DateTime'],
  createdBy: User,
  preset?: Maybe<TranscodePreset>,
  type: SourceType,
};

export type TranscodePreset = {
   __typename?: 'TranscodePreset',
  id: Scalars['ID'],
  name: Scalars['String'],
  parameter: Array<Scalars['String']>,
};

export type TranscodePresetList = {
   __typename?: 'TranscodePresetList',
  presets: Array<TranscodePreset>,
  total: Scalars['Int'],
};

export enum TranscodeStatus {
  Pending = 'pending',
  Waiting = 'waiting',
  Running = 'running',
  Success = 'success',
  Failed = 'failed'
}


export type UploadFileChunk = {
  chunk: Scalars['Upload'],
  begin: Scalars['Int'],
  size: Scalars['Int'],
};

export type UploadFileInfo = {
  filename: Scalars['String'],
  size: Scalars['Int'],
};

export type User = {
   __typename?: 'User',
  id: Scalars['ID'],
  userId: Scalars['ID'],
  screenName: Scalars['String'],
  iconUrl?: Maybe<Scalars['String']>,
  role: UserRole,
  type: IdPType,
};

export enum UserRole {
  Normal = 'normal',
  Admin = 'admin'
}

export type Users = {
   __typename?: 'Users',
  users: Array<User>,
  total: Scalars['Int'],
};

export type ViewerChallenge = {
   __typename?: 'ViewerChallenge',
  token: Scalars['String'],
  code: Scalars['String'],
};

export type ViewerChallengeRequest = {
   __typename?: 'ViewerChallengeRequest',
  id: Scalars['ID'],
  requestFrom: Scalars['String'],
  code: Scalars['String'],
  type: DeviceType,
  createdAt: Scalars['DateTime'],
};

export type ViewerChallengeResult = {
   __typename?: 'ViewerChallengeResult',
  success: Scalars['Boolean'],
  token: Scalars['String'],
};

export type ViewerDevice = {
   __typename?: 'ViewerDevice',
  id: Scalars['ID'],
  type: DeviceType,
  displayName: Scalars['String'],
  volume: Scalars['Int'],
  state: ViewerState,
  playingContent?: Maybe<Playbackable>,
  online: Scalars['Boolean'],
  elapsed?: Maybe<Scalars['Float']>,
  message?: Maybe<Scalars['String']>,
};

export type ViewerDeviceList = {
   __typename?: 'ViewerDeviceList',
  total: Scalars['Int'],
  devices: Array<ViewerDevice>,
};

export type ViewerMetricsParam = {
  type: ViewerMetricsType,
  elapsed?: Maybe<Scalars['Float']>,
  message?: Maybe<Scalars['String']>,
};

export enum ViewerMetricsType {
  Elapsed = 'elapsed',
  Error = 'error',
  Ping = 'ping',
  Ended = 'ended'
}

export type ViewerRequestParam = {
  device: Scalars['ID'],
  type: ViewerRequestType,
  sourceType?: Maybe<ViewerSourceType>,
  sourceId?: Maybe<Scalars['ID']>,
  volume?: Maybe<Scalars['Int']>,
};

export enum ViewerRequestType {
  Play = 'play',
  Stop = 'stop',
  Volume = 'volume'
}

export enum ViewerSourceType {
  Channel = 'channel',
  Source = 'source'
}

export enum ViewerState {
  Playing = 'playing',
  Stopped = 'stopped'
}

export type GetNearSchedulesQueryVariables = {
  channelId: Scalars['String'],
  now: Scalars['DateTime']
};


export type GetNearSchedulesQuery = (
  { __typename?: 'Query' }
  & { scheduleList: (
    { __typename?: 'ScheduleList' }
    & { schedules: Array<(
      { __typename?: 'Schedule' }
      & Pick<Schedule, 'id' | 'startAt' | 'endAt'>
    )> }
  ) }
);

export type ReportMetricsMutationVariables = {
  data: ViewerMetricsParam
};


export type ReportMetricsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'reportViewerMetrics'>
);

export type CreateChallengeMutationVariables = {
  type: DeviceType
};


export type CreateChallengeMutation = (
  { __typename?: 'Mutation' }
  & { createViewerChallenge: (
    { __typename?: 'ViewerChallenge' }
    & Pick<ViewerChallenge, 'token' | 'code'>
  ) }
);

export type GetChallengeResultQueryVariables = {
  token: Scalars['String']
};


export type GetChallengeResultQuery = (
  { __typename?: 'Query' }
  & { viewerChallengeResult: (
    { __typename?: 'ViewerChallengeResult' }
    & Pick<ViewerChallengeResult, 'success' | 'token'>
  ) }
);

export type GetSourceSimpleQueryVariables = {
  sourceId: Scalars['ID']
};


export type GetSourceSimpleQuery = (
  { __typename?: 'Query' }
  & { source: (
    { __typename: 'FileSource' }
    & Pick<FileSource, 'name'>
  ) | (
    { __typename: 'RecordSource' }
    & Pick<RecordSource, 'name'>
  ) | { __typename: 'RtmpInput' } }
);

export type ViewerDeviceWithStateFragment = (
  { __typename?: 'ViewerDevice' }
  & Pick<ViewerDevice, 'id' | 'displayName' | 'volume' | 'state'>
  & { playingContent: Maybe<(
    { __typename?: 'FileSource' }
    & Pick<FileSource, 'id' | 'name'>
  ) | (
    { __typename?: 'RecordSource' }
    & Pick<RecordSource, 'id' | 'name'>
  ) | (
    { __typename?: 'Channel' }
    & Pick<Channel, 'displayName'>
    & { channelId: Channel['id'] }
  )> }
);

export type GetViewerInfoQueryVariables = {};


export type GetViewerInfoQuery = (
  { __typename?: 'Query' }
  & { viewerInfo: Maybe<(
    { __typename?: 'ViewerDevice' }
    & ViewerDeviceWithStateFragment
  )> }
);

export type ViewerUpdateSubscriptionVariables = {};


export type ViewerUpdateSubscription = (
  { __typename?: 'Subscription' }
  & { viewerUpdate: (
    { __typename?: 'ViewerDevice' }
    & ViewerDeviceWithStateFragment
  ) }
);

export const ViewerDeviceWithStateFragmentDoc = gql`
    fragment viewerDeviceWithState on ViewerDevice {
  id
  displayName
  volume
  state
  playingContent {
    ... on TranscodedSource {
      id
      name
    }
    ... on Channel {
      channelId: id
      displayName
    }
  }
}
    `;
export const GetNearSchedulesDocument = gql`
    query getNearSchedules($channelId: String!, $now: DateTime!) {
  scheduleList(skip: 0, take: 5, startAt: $now, channel: [$channelId]) {
    schedules {
      id
      startAt
      endAt
    }
  }
}
    `;

/**
 * __useGetNearSchedulesQuery__
 *
 * To run a query within a React component, call `useGetNearSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNearSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNearSchedulesQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      now: // value for 'now'
 *   },
 * });
 */
export function useGetNearSchedulesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNearSchedulesQuery, GetNearSchedulesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetNearSchedulesQuery, GetNearSchedulesQueryVariables>(GetNearSchedulesDocument, baseOptions);
      }
export function useGetNearSchedulesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNearSchedulesQuery, GetNearSchedulesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetNearSchedulesQuery, GetNearSchedulesQueryVariables>(GetNearSchedulesDocument, baseOptions);
        }
export type GetNearSchedulesQueryHookResult = ReturnType<typeof useGetNearSchedulesQuery>;
export type GetNearSchedulesLazyQueryHookResult = ReturnType<typeof useGetNearSchedulesLazyQuery>;
export type GetNearSchedulesQueryResult = ApolloReactCommon.QueryResult<GetNearSchedulesQuery, GetNearSchedulesQueryVariables>;
export const ReportMetricsDocument = gql`
    mutation reportMetrics($data: ViewerMetricsParam!) {
  reportViewerMetrics(metrics: $data)
}
    `;
export type ReportMetricsMutationFn = ApolloReactCommon.MutationFunction<ReportMetricsMutation, ReportMetricsMutationVariables>;

/**
 * __useReportMetricsMutation__
 *
 * To run a mutation, you first call `useReportMetricsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportMetricsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportMetricsMutation, { data, loading, error }] = useReportMetricsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useReportMetricsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReportMetricsMutation, ReportMetricsMutationVariables>) {
        return ApolloReactHooks.useMutation<ReportMetricsMutation, ReportMetricsMutationVariables>(ReportMetricsDocument, baseOptions);
      }
export type ReportMetricsMutationHookResult = ReturnType<typeof useReportMetricsMutation>;
export type ReportMetricsMutationResult = ApolloReactCommon.MutationResult<ReportMetricsMutation>;
export type ReportMetricsMutationOptions = ApolloReactCommon.BaseMutationOptions<ReportMetricsMutation, ReportMetricsMutationVariables>;
export const CreateChallengeDocument = gql`
    mutation createChallenge($type: DeviceType!) {
  createViewerChallenge(device: $type) {
    token
    code
  }
}
    `;
export type CreateChallengeMutationFn = ApolloReactCommon.MutationFunction<CreateChallengeMutation, CreateChallengeMutationVariables>;

/**
 * __useCreateChallengeMutation__
 *
 * To run a mutation, you first call `useCreateChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChallengeMutation, { data, loading, error }] = useCreateChallengeMutation({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateChallengeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateChallengeMutation, CreateChallengeMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateChallengeMutation, CreateChallengeMutationVariables>(CreateChallengeDocument, baseOptions);
      }
export type CreateChallengeMutationHookResult = ReturnType<typeof useCreateChallengeMutation>;
export type CreateChallengeMutationResult = ApolloReactCommon.MutationResult<CreateChallengeMutation>;
export type CreateChallengeMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateChallengeMutation, CreateChallengeMutationVariables>;
export const GetChallengeResultDocument = gql`
    query getChallengeResult($token: String!) {
  viewerChallengeResult(token: $token) {
    success
    token
  }
}
    `;

/**
 * __useGetChallengeResultQuery__
 *
 * To run a query within a React component, call `useGetChallengeResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChallengeResultQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChallengeResultQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetChallengeResultQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetChallengeResultQuery, GetChallengeResultQueryVariables>) {
        return ApolloReactHooks.useQuery<GetChallengeResultQuery, GetChallengeResultQueryVariables>(GetChallengeResultDocument, baseOptions);
      }
export function useGetChallengeResultLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetChallengeResultQuery, GetChallengeResultQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetChallengeResultQuery, GetChallengeResultQueryVariables>(GetChallengeResultDocument, baseOptions);
        }
export type GetChallengeResultQueryHookResult = ReturnType<typeof useGetChallengeResultQuery>;
export type GetChallengeResultLazyQueryHookResult = ReturnType<typeof useGetChallengeResultLazyQuery>;
export type GetChallengeResultQueryResult = ApolloReactCommon.QueryResult<GetChallengeResultQuery, GetChallengeResultQueryVariables>;
export const GetSourceSimpleDocument = gql`
    query getSourceSimple($sourceId: ID!) {
  source(sourceId: $sourceId) {
    __typename
    ... on FileSource {
      name
    }
    ... on RecordSource {
      name
    }
  }
}
    `;

/**
 * __useGetSourceSimpleQuery__
 *
 * To run a query within a React component, call `useGetSourceSimpleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSourceSimpleQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSourceSimpleQuery({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *   },
 * });
 */
export function useGetSourceSimpleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSourceSimpleQuery, GetSourceSimpleQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSourceSimpleQuery, GetSourceSimpleQueryVariables>(GetSourceSimpleDocument, baseOptions);
      }
export function useGetSourceSimpleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSourceSimpleQuery, GetSourceSimpleQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSourceSimpleQuery, GetSourceSimpleQueryVariables>(GetSourceSimpleDocument, baseOptions);
        }
export type GetSourceSimpleQueryHookResult = ReturnType<typeof useGetSourceSimpleQuery>;
export type GetSourceSimpleLazyQueryHookResult = ReturnType<typeof useGetSourceSimpleLazyQuery>;
export type GetSourceSimpleQueryResult = ApolloReactCommon.QueryResult<GetSourceSimpleQuery, GetSourceSimpleQueryVariables>;
export const GetViewerInfoDocument = gql`
    query getViewerInfo {
  viewerInfo {
    ...viewerDeviceWithState
  }
}
    ${ViewerDeviceWithStateFragmentDoc}`;

/**
 * __useGetViewerInfoQuery__
 *
 * To run a query within a React component, call `useGetViewerInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewerInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewerInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetViewerInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetViewerInfoQuery, GetViewerInfoQueryVariables>) {
        return ApolloReactHooks.useQuery<GetViewerInfoQuery, GetViewerInfoQueryVariables>(GetViewerInfoDocument, baseOptions);
      }
export function useGetViewerInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetViewerInfoQuery, GetViewerInfoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetViewerInfoQuery, GetViewerInfoQueryVariables>(GetViewerInfoDocument, baseOptions);
        }
export type GetViewerInfoQueryHookResult = ReturnType<typeof useGetViewerInfoQuery>;
export type GetViewerInfoLazyQueryHookResult = ReturnType<typeof useGetViewerInfoLazyQuery>;
export type GetViewerInfoQueryResult = ApolloReactCommon.QueryResult<GetViewerInfoQuery, GetViewerInfoQueryVariables>;
export const ViewerUpdateDocument = gql`
    subscription viewerUpdate {
  viewerUpdate {
    ...viewerDeviceWithState
  }
}
    ${ViewerDeviceWithStateFragmentDoc}`;

/**
 * __useViewerUpdateSubscription__
 *
 * To run a query within a React component, call `useViewerUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useViewerUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useViewerUpdateSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<ViewerUpdateSubscription, ViewerUpdateSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<ViewerUpdateSubscription, ViewerUpdateSubscriptionVariables>(ViewerUpdateDocument, baseOptions);
      }
export type ViewerUpdateSubscriptionHookResult = ReturnType<typeof useViewerUpdateSubscription>;
export type ViewerUpdateSubscriptionResult = ApolloReactCommon.SubscriptionResult<ViewerUpdateSubscription>;